import React, { Fragment, useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
// import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { FormGroup } from 'react-bootstrap';
import TimePicker from 'react-times';
import 'react-times/css/classic/default.css';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { DatePickerInput } from 'rc-datepicker';
// import DatePicker from 'components/sales/datePicker/datePicker';
// import FileUpload from 'components/sales/fileUpload/fileUpload';
import './carnival.css';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
// import ReactTooltip from "react-tooltip";
import { handleValidateObj } from 'constants/objValues/objvalues';

const CarnivalForm = ({
  handleValue,
//   siteId,
  leadInfraId,
  documentUploadUrl,
  documentUrlData,
  getLeadInfraId,
  prefilledData
}) => {
    const inputs = {
        services: '',
        start_date: '',
        start_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
        end_date: '',
        end_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
        // subject: '',
        members: '',
        // id: '',
        rwa_members: '',
        rwaImage: '',
        services_data: '',
        event_details:'',
        gst_number : '',
        bank_name : '',
        act_number : '',
        ifsc_code: '',
        branch_name: '',
        is_gst_available: '',
        carnival_type: ''
    };
    const [inputList, setInputList] = useState([{ name:"",image_url: "", position: ""}]);
    const [formData, setData] = useState(inputs);
    const [infraId, setInfraId] = useState(0);
    const [projectName, setProjectName] = useState();
    const [infraIdToCheck, setInfraIdToCheck] = useState();
    const [services, setServices] = useState();
    // const [rwaMember, setRwaMember] = useState();
    const [minDateIndex, setMinDateIndex] = useState(null);
    const [addMembers, setAddMembers] = useState(0);
    const [isEditForm, setIsEditForm] = useState(false);
    // const [rwaImage, setRwaImage] = useState();
    const[selectedLocation,setSelectedLocation]=useState(null);

    useEffect(() => {
        if (!formData.partners || formData.partners.length === 0) {
        setData({
            ...formData,
            partners: [{ companyName: '', cost: '' }],
        });
        }
    }, [formData, setData]);

    useEffect(() => {
        if (leadInfraId?.status == 1 && leadInfraId.infra_project_id == infraIdToCheck) {
            if (leadInfraId?.infra_project_id) {
                setInfraId(leadInfraId?.infra_project_id);
                setProjectName(leadInfraId?.project_name);
                setData({ ...formData, subject: leadInfraId?.project_name })
            }
            if (leadInfraId?.services) {
                setServices(leadInfraId.services);
            }
        } 
        if(leadInfraId?.status == 0 && infraIdToCheck !== null) {
            // console.log('rete');
            toast.error('Project Id not found.');
            setInfraId(0);
        }
    }, [leadInfraId]);

    const handleStartDate = (date, dateString) => {
        setData({ ...formData, start_date: dateString });
        setMinDateIndex(dateString);
    };

    const handleEndDate = (date, dateString) => {
        setData({ ...formData, end_date: dateString });
    };

    useEffect(() => {
        if (prefilledData?.carnival !== null && prefilledData?.carnival !== undefined) {
            const {
                id,
                infra_id,
                name,
                start_date,
                start_time,
                end_date,
                end_time,
                services,
                // members,
                project_name,
                gst_number,
                bank_name,
                act_number,
                branch_name,
                ifsc_code,
                bank_details,
                // member_exists,
                event_details,
                partner_details
            } = prefilledData?.carnival;
            checkInfraId(infra_id);
            // setTimeout(() => {
                setInfraIdToCheck(infra_id);
                setInfraId(infra_id);
                setProjectName(project_name);
                setIsEditForm(true);
                setData({ ...formData,
                    isEdit: 1,
                    // subject: name,
                    services: services,
                    start_date: start_date,
                    end_date: end_date,
                    start_time: start_time,
                    end_time: end_time,
                    gst_number,
                    ifsc_code: bank_details.ifsc_code,
                    branch_name: bank_details.branch_name,
                    bank_name: bank_details.bank_name,
                    act_number: bank_details.act_number,
                    // rwa_members: (member_exists == 1) ? 1 : 2,
                    // members: (member_exists == 1) ? members : null,
                    // rwaImage: (member_exists == 2) ? members : null,
                    carnival_id: id,
                    event_details:event_details,
                    bank_details,
                    partners: partner_details
                    // services_data: services_data
                });
                // setInputList((member_exists == 1) ? members : [{ name:"",image_url: "", position: ""}]);
                // setRwaMember((member_exists == 1) ? 'Yes' : 'No');
                // setAddMembers(member_exists);
            // }, 100);
            
        }
    }, [prefilledData])

  const handleMeetingData = () => {
    if (
        // formData.services?.length > 0 &&
        formData.start_date !== '' &&
        formData.end_date !== '' &&
        formData.start_time !== '' &&
        formData.end_time !== '' &&
        formData.subject !== '' 
        // && formData.event_details!== ''
    ) {
        handleValue({ ...formData, members: inputList, infra_id: infraId });
    } else handleValue(null);
  };
  useEffect(() => {
    handleMeetingData();
  }, [formData, inputList]);

    function onStartChange(value) {
        const { hour, minute } = value;
        setData({ ...formData, start_time: `${hour}:${minute}` });
    }
    function onEndChange(value) {
        const { hour, minute } = value;
        setData({ ...formData, end_time: `${hour}:${minute}` });
    }

    // handle input change
    const handleInputChange = (e, index, type) => {
        const { name, value } = e.target;
        const list = [...inputList];
        list[index][type] = value;
        setInputList(list);
    };
    const saveImage = (val, index=null) => {
        if (index != null) {
            const list = [...inputList];
            list[index]["image_url"] = val;
            setInputList(list);
        } else {
            if (prefilledData?.carnival.member_exists == 2) {
                setData({ ...formData, rwaImage: prefilledData?.carnival.members });
            } else {
                setData({ ...formData, rwaImage: val });
            }
        }
    };
    const handlePriceChange = (val, index) => {
        const list2 = formData.services;
        list2[index]["price"] = val;
        setData({
            ...formData,
            services: list2,
        })
    };

    const handlePartnerChange = (index, field, value) => {
        const updatedPartners = [...formData.partners];
        updatedPartners[index][field] = value;
        setData({ ...formData, partners: updatedPartners });
      };
    
      const addPartner = () => {
        setData({
          ...formData,
          partners: [...formData.partners, { companyName: '', cost: '' }],
        });
      };
    
      const removePartner = (index) => {
        if (formData.partners.length > 1) {
          const updatedPartners = [...formData.partners];
          updatedPartners.splice(index, 1);
          setData({ ...formData, partners: updatedPartners });
        }
      };
      
    // handle click event of the Remove button
    /*const handleRemoveClick = index => {
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
    };
    // handle click event of the Add button
    const handleAddClick = () => {
        var size = Object.keys(inputList).length;
        if (size >= 3) {
            toast.error('RWA members limit cannot exceed 3.');
        } else {
            setInputList([...inputList, { name:"",image_url: "", position: ""}]);
        }
    };*/
    const checkInfraId = (infra_id) => {
        (async () => {
              let res = await getLeadInfraId((infraIdToCheck !== undefined) ? infraIdToCheck : infra_id);
              if (res?.resultSets) {
              }
            })();
    };
    const calculateServices = () => {
      // console.log(formData.services);
        if (formData.services?.length > 0) {
            return (
                
                formData.services.map((x, i) => {
                    return (
                    <>
                    <div className="row">
                        {/* <div className="col-md-1 col-sm-12"></div> */}
                        <div className="col-md-5  col-sm-12">
                        <ConstantInput
                            label={localization.serviceName}
                            value={x.name}
                            disabled
                        />
                        </div>
                      { x.id == 1 || x.id == 2 ?
                        <div className="col-md-5  col-sm-12">
                          <ConstantInput
                              type="text"
                              errorMsg={localization.requiredPromo}
                              label={localization.promocode}
                              required
                              isStarRequired={true}
                              // max={500}
                              // handleChange={(val) =>
                              //     setData({
                              //         ...formData,
                              //         prices: val,
                              //     })
                              // }
                              handleChange={e => handlePriceChange(e, i)}
                              value = {x?.price}
                              disabled = {isEditForm}
                              // regex={Regex.numericNotZero.test(formData.quantity)}
                          />
                        </div>
                          : null
                      }

                        {/*{ i==0 ?
                            <div className="col-md-2 col-sm-12">
                                <button className="btn btn-sm btn-primary" data-tip data-for="registerTip">
                                    Suggestion
                                </button>

                                <ReactTooltip id="registerTip" place="left" type="info">
                                    - Sum of price should not exceed 1000.
                                    <br/>- For 2 services, price can 500 for both of them.
                                    <br/>- For 3 services, price can be 200, 300 & 500.
                                </ReactTooltip>
                            </div>
                        
                        : null}*/}
                    </div>
                    <hr/>
                    </>
                );
            })
            );
        }
    };

    /*const handleMemberChange = (val) => {
        setAddMembers(val.id);
        setData({ ...formData, rwa_members: val.id })
    };*/
  return (
    <FormSection title={localization.carnivalDetails}>
        <div className="row">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={localization.projectId}
                    value={infraId !== 0 ? infraId : null}
                    handleChange={(value) => setInfraIdToCheck(value)}
                    disabled={formData?.isEdit}
                />
            </div>
            <div className="col-md-2 col-sm-5">
                <button className="btn btn-sm btn-primary" onClick={checkInfraId}>Check</button>
            </div>

        </div>
        
        {infraId !== 0 ? (
        <>
        <div className="row form-group">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={localization.projectName}
                    value={projectName}
                    disabled
                />
            </div>
            {/*<div className="col-md-6 col-sm-12">
                <ConstantInput
                    value={formData.subject}
                    label={localization.societyName}
                    errorMsg={localization.enterSocietyName}
                    type="text"
                    maxLength={20}
                    required
                    handleChange={(value) => setData({ ...formData, subject: value })}
                    isStarRequired={true}
                    fullWidth
                />
            </div>*/}
        </div>
          <div className="row form-group">
            <div className="col-md-6 col-sm-12">
                <FormGroup
                    className={`date custom_date_picker active-date`}
                >
                    <DatePickerInput
                    value={formData?.start_date ? new Date(formData?.start_date) : null}
                    onChange={handleStartDate}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    required
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    minDate={new Date()}
                    // value={formData?.start_date}
                    />
                    <label>
                    {localization.startDate}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span>
                    </label>
                
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup>
                    <TimePicker
                    theme="classic"
                    timeFormat="HH:MM"
                    timeMode={24}
                    time={formData?.start_time}
                    onTimeChange={onStartChange}
                    />
                    <label>{localization.startTime}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span></label>
                    <label className="error date_error">{localization.isRequired}</label>
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup
                    className={`date custom_date_picker active-date`}
                >
                    <DatePickerInput
                    value={formData?.end_date ? new Date(formData?.end_date) : null}
                    onChange={handleEndDate}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    required
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    minDate={minDateIndex === null 
                        ? new Date()
                        : minDateIndex}
                    />
                    <label>
                    {localization.endDate}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span>
                    </label>
                
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup>
                    <TimePicker
                    theme="classic"
                    timeFormat="HH:MM"
                    timeMode={24}
                    time={formData?.end_time}
                    onTimeChange={onEndChange}
                    />
                    <label>{localization.endTime}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span></label>
                    <label className="error date_error">{localization.isRequired}</label>
                </FormGroup>
            </div>

            {formData?.gst_number !='' && 
                <div className="col-md-6 col-sm-12">
                    <ConstantInput
                        label={'Gst Number'}
                        type={'text'}
                        value={formData?.gst_number}
                        handleChange={(value) => setData({
                            ...formData,
                            gst_number: value,
                        })}
                        disabled={formData?.isEdit}
                    />
                </div>
            }

        </div>

        <div className="row form-group">
            
        </div>

        {(formData?.services?.length) > 0 &&
        <FormSection title={localization.serviceDetails}>
            <div className="form-group">
                    <DropDownInput
                        multipule
                        // selectedList={pocsList.length > 0 ? pocsList : []}
                        data={services}
                        label={localization.services}
                        required
                        errorMsg={localization.requiredServices}
                        getIdValue={(val) => {
                        const list = val;
                        if (list.length > 0 && JSON.stringify(formData.services) !== JSON.stringify(list)) {
                            setData({
                                ...formData,
                                services: list
                            });
                        }
                        }}
                        isStarRequired={true}
                        selectedList={isEditForm ? formData?.services??[] : []}
                        disabled = {isEditForm}
                    />
            </div>
            <>
            {formData.services?.length > 0 ?
                (calculateServices())
                :null
            }
            </>
        </FormSection>
        }

        <FormSection title={localization.eventDetails}>
            <div className="col-md-6 col-sm-12">
                <DropDownInput
                    data={[
                        {
                            "id":"Confirmed",
                            "name":"Confirmed"
                        },
                        {
                            "id":"Tentative",
                            "name":"Tentative"
                        }
                    ]}
                    label={localization.eventStatus}
                    required
                    errorMsg={localization.requiredEventStatus}
                    getIdValue={(val) => {
                        setData({
                            ...formData,
                            event_status: val.id,
                        });
                    }}
                    isStarRequired={true}
                    value={isEditForm ? formData?.event_details?.event_status : ''}
                    disabled = {isEditForm}
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                            label={'Total footfall'}
                            type={'number'}
                            value={isEditForm ? formData?.event_details?.total_footfall : ''}
                            handleChange={(value) => setData({
                                ...formData,
                                total_footfall: value,
                            })}
                            disabled={formData?.isEdit}
                            isStarRequired={true}
                        />
            </div>
            {/* <div className="col-md-6 col-sm-12">
                <ConstantInput
                            label={'Total Tags Issued'}
                            type={'number'}
                            value={isEditForm ? formData?.event_details?.total_tags_issued : ''}
                            handleChange={(value) => setData({
                                ...formData,
                                total_tags_issued: value,
                            })}
                            disabled={formData?.isEdit}
                            isStarRequired={true}
                        />
            </div> */}
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                            label={'Manpower required'}
                            type={'number'}
                            value={isEditForm ? formData?.event_details?.manpower_required : ''}
                            handleChange={(value) => setData({
                                ...formData,
                                manpower_required: value,
                            })}
                            disabled={formData?.isEdit}
                            isStarRequired={true}
                        />
            </div>
            <div className="col-md-6 col-sm-12">
                <DropDownInput
                    data={[
                        {
                            "id":"Yes",
                            "name":"Yes"
                        },
                        {
                            "id":"No",
                            "name":"No"
                        }
                    ]}
                    label={'Partner allowed'}
                    required
                    errorMsg={'Partner allowed is required'}
                    getIdValue={(val) => {
                        setData({
                            ...formData,
                            partner_allowed: val.id,
                        });
                    }}
                    isStarRequired={true}
                    value={isEditForm ? formData?.event_details?.partner_allowed : ''}
                    disabled = {isEditForm}
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={'Location'}
                    type={'text'}
                    value={formData?.event_details?.location}
                    disabled={true}
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={'Latitude'}
                    type={'number'}
                    value={formData?.event_details?.lat}
                    disabled={true}
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={'Longitude'}
                    type={'number'}
                    value={formData?.event_details?.lat}
                    disabled={true}
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                            label={'Remarks'}
                            type={'text'}
                            value={isEditForm ? formData?.event_details?.remarks : ''}
                            handleChange={(value) => setData({
                                ...formData,
                                remarks: value,
                            })}
                            disabled={formData?.isEdit}
                        />
            </div>
        </FormSection>

        {formData?.bank_details && Object.keys(formData.bank_details).length > 0 && (
        <FormSection title="Bank Details">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'Bank Name'}
                type={'text'}
                value={isEditForm ? formData?.bank_name : ''}
                handleChange={(value) => setData({
                    ...formData,
                    bank_name: value,
                    bank_details: {
                        ...formData.bank_details,
                        bank_name: value
                    }
                })} 
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'Account Number'}
                type={'number'}
                value={isEditForm ? formData?.act_number : ''}
                handleChange={(value) => setData({
                    ...formData,
                    act_number: value,
                    bank_details: {
                        ...formData.bank_details,
                        act_number: value
                    }
                })} 
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'IFSC Code'}
                type={'text'}
                value={isEditForm ? formData?.ifsc_code : ''}
                handleChange={(value) => setData({
                    ...formData,
                    ifsc_code: value,
                    bank_details: {
                        ...formData.bank_details,
                        ifsc_code: value
                    }
                })}
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'Branch Name of the bank'}
                type={'text'}
                value={isEditForm ? formData?.branch_name : ''}
                handleChange={(value) => setData({
                    ...formData,
                    branch_name: value,
                    bank_details: {
                        ...formData.bank_details,
                        branch_name: value
                    }
                })}
                />
            </div>
        </FormSection>
        )}

        <FormSection title="Partner Details">
        {(formData.partners || []).map((partner, index) => (
            <div key={index} className="row mb-3 border p-2">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label="Name of the Company"
                type="text"
                // isStarRequired={true}
                value={partner.companyName}
                handleChange={(value) => handlePartnerChange(index, 'companyName', value)}
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label="Cost of Partner"
                type="number"
                // isStarRequired={true}
                value={partner.cost}
                handleChange={(value) => handlePartnerChange(index, 'cost', value)}
                />
            </div>

            {formData.partners.length > 1 && (
                <div className="col-md-12 mt-2">
                <button
                    type="button"
                    className="btn btn-danger btn-sm me-2"
                    onClick={() => removePartner(index)}
                >
                    Remove
                </button>
                </div>
            )}
            </div>
        ))}

        <div className="col-md-12">
            <button
            type="button"
            className="btn btn-sm btn-primary me-2"
            onClick={addPartner}
            >
            Add Partner
            </button>
        </div>
        </FormSection>

          {/*<FormSection title={localization.memberDetails}>
            <div className="row form-group">
                <div className="col-md-3 col-sm-12">
                    <DropDownInput
                        data={[
                            { name: 'Yes', id: 1 },
                            { name: 'No', id: 2 }
                        ]}
                        label={localization.addMembers}
                        required={true}
                        isStarRequired={true}
                        errorMsg={localization.isRequired}
                        getIdValue={(val) => handleMemberChange(val)}
                        value={rwaMember}
                    />
                </div>
            </div>
            {addMembers === 1 ? (
                <>
                {inputList.map((x, i) => {
                return (
                    <div className="row form-group">
                        <div className="col-md-4 col-sm-12">
                            <input
                                type="text"
                                className="form-control"
                                name="member_name"
                                placeholder="Member name"
                                onChange={e => handleInputChange(e, i, "name")}
                                required={true}
                                value={x?.name}
                            />
                        </div>
                        
                        <div className="col-md-4 col-sm-12">
                            <input
                                className="form-control"
                                name="designation"
                                placeholder="Designation"
                                onChange={e => handleInputChange(e, i, "position")}
                                required={true}
                                value={x?.position}
                            />
                        </div>
                        <div className="col-md-2 col-sm-12">
                            <FileUpload
                                id={"addAttachment" + i}
                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                documentUploadUrl={documentUploadUrl}
                                documentUrlData={documentUrlData}
                                onChange={(val) =>
                                    saveImage(val, i)
                                }
                                prefilledFilename={x?.image_url}
                                // value={x?.image_url}
                                >
                                <span className="btn btn-transparent">
                                    {localization.image}
                                </span>
                            </FileUpload>
                        </div>

                         <div className="btn-box">
                            {inputList.length !== 1 && 
                            <div className="col-md-2 col-sm-5">
                            <button
                            onClick={() => handleRemoveClick(i)} 
                            className="mr10 btn btn-sm btn-danger">Remove</button>
                            </div>
                            }
                            {inputList.length - 1 === i && 
                            <div className="col-md-2 col-sm-5">
                            <button className="btn btn-sm btn-primary" onClick={handleAddClick}>Add</button>
                            </div>
                            }
                         </div>
                    </div>
                );
                })}
                </>
            ) : (addMembers === 2) ?
                <div className="row form-group">
                    <div className="col-md-3 col-sm-12">
                        <FileUpload
                            id={"addRwaImage"}
                            accept=".pdf,.png,.jpg,.jpeg,.doc"
                            documentUploadUrl={documentUploadUrl}
                            documentUrlData={documentUrlData}
                            onChange={(val) =>
                                saveImage(val)
                            }
                            // value={formData?.rwaImage}
                            prefilledFilename={formData?.rwaImage}
                            >
                            <span className="btn btn-transparent">
                                {localization.uploadCarnivalImage}
                            </span>
                        </FileUpload>
                    </div>
                </div>
            : null}
        </FormSection>*/}
        </>
        ) : null}

    </FormSection>
  );
};

CarnivalForm.propTypes = {};

export default CarnivalForm;
